export default __webpack_public_path__ + "static/media/Sage's Bracers of the Bloody Stone.0e9b857f.jpg";